export default __webpack_public_path__ + "static/media/SV1.88358076.jpeg";